var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStopCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-512-512s229.23-512 512-512z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M512 153.6c-70.885 0-140.177 21.020-199.116 60.401s-104.876 95.356-132.002 160.845c-27.127 65.489-34.224 137.553-20.395 207.072 13.829 69.524 47.963 133.386 98.086 183.506 50.123 50.125 113.983 84.26 183.506 98.089s141.585 6.733 207.075-20.393c65.49-27.131 121.462-73.068 160.845-132.004 39.383-58.941 60.401-128.23 60.401-199.117 0-95.054-37.76-186.214-104.975-253.427-67.21-67.213-158.372-104.973-253.425-104.973zM665.6 614.4c0 13.578-5.396 26.604-14.996 36.204s-22.625 14.996-36.204 14.996h-204.8c-13.579 0-26.602-5.396-36.204-14.996s-14.996-22.625-14.996-36.204v-204.8c0-13.579 5.394-26.602 14.996-36.204s22.625-14.996 36.204-14.996h204.8c13.578 0 26.604 5.394 36.204 14.996s14.996 22.625 14.996 36.204v204.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopCircle);
export default __webpack_public_path__ + "static/media/icon-stop-circle.08c99a8ed553fa98da29cf8b0e16b17e.svg";
export { ForwardRef as ReactComponent };